import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-medicallicensereportbystate',
  templateUrl: './medicallicensereportbystate.component.html',
  styleUrls: ['./medicallicensereportbystate.component.scss']
})
export class MedicallicensereportbystateComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
